import { useState } from 'react';
import { SettingsTabs } from '@/components/settings/settings-tabs';
import { IntegrationsTab } from '@/components/settings/integrations-tab';
import { TeamTab } from '@/components/settings/team-tab';
import { AppearanceTab } from '@/components/settings/appearance-tab';
import { NotificationPreferencesTab } from '@/components/settings/notification-preferences-tab';
import { ProfileSettingsTab } from '@/components/settings/profile-settings-tab';
import { PrivacyTab } from '@/components/settings/privacy-tab';
import { CreditCard, Languages } from 'lucide-react';
import { useI18n, useT } from '@/lib/i18n';

export function SettingsPage() {
  const [activeTab, setActiveTab] = useState('profile');
  const tFn = useT();
  const { locale, setLocale } = useI18n();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">{tFn('settings.title')}</h1>

      <SettingsTabs activeTab={activeTab} onTabChange={setActiveTab} />

      <div className="pt-2">
        {activeTab === 'profile' && <ProfileSettingsTab />}

        {activeTab === 'integrations' && <IntegrationsTab />}

        {activeTab === 'team' && <TeamTab />}

        {activeTab === 'notifications' && <NotificationPreferencesTab />}

        {activeTab === 'appearance' && <AppearanceTab />}

        {activeTab === 'privacy' && <PrivacyTab />}

        {activeTab === 'billing' && (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <CreditCard className="mb-3 h-10 w-10 text-muted-foreground/50" />
            <h3 className="text-sm font-semibold">Billing</h3>
            <p className="mt-1 max-w-sm text-sm text-muted-foreground">
              Stripe billing integration with subscriptions, usage metering, and invoicing coming in
              Phase 2d.
            </p>
          </div>
        )}
      </div>

      <div className="rounded-lg border p-6">
        <div className="flex items-center gap-2 mb-4">
          <Languages className="h-5 w-5 text-muted-foreground" />
          <h2 className="text-sm font-semibold">{tFn('settings.language')}</h2>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => setLocale('en')}
            className={`rounded-md border px-4 py-2 text-sm font-medium transition-colors ${
              locale === 'en'
                ? 'border-primary bg-primary/10 text-primary'
                : 'border-border text-muted-foreground hover:border-foreground hover:text-foreground'
            }`}
          >
            EN
          </button>
          <button
            onClick={() => setLocale('sv')}
            className={`rounded-md border px-4 py-2 text-sm font-medium transition-colors ${
              locale === 'sv'
                ? 'border-primary bg-primary/10 text-primary'
                : 'border-border text-muted-foreground hover:border-foreground hover:text-foreground'
            }`}
          >
            SV
          </button>
        </div>
      </div>
    </div>
  );
}
